import { fetchEB } from '@eventbrite/legacy-infra.http';
import { deepKeysToSnake } from '@eventbrite/legacy-infra.transformation-utils';
import { skipFeedbackReasons } from '../constants';

interface Report {
    userId?: string;
    email: string;
    eventId: string;
    reportMessage: string;
    reportReason: string;
    eventUrl: string;
    eventName: string;
    regulation?: string;
}

export const reportEvent = async ({
    userId,
    email,
    eventId,
    reportMessage,
    reportReason,
    eventUrl,
    eventName,
    regulation = '',
}: Report): Promise<Response> => {
    // Call feedback first if report reason is not in the skip list
    if (!skipFeedbackReasons.includes(reportReason)) {
        try {
            await fetchEB('/ajax/feedback/', {
                method: 'POST',
                body: JSON.stringify(
                    deepKeysToSnake({
                        userId: userId,
                        email: email,
                        eventId: eventId,
                        feedbackType: 'report_this_event_feedback',
                        type: 'event',
                        reportMessage: reportMessage,
                        reportReason: reportReason,
                    }),
                ),
            });
        } catch (error) {
            // Intentionally do nothing
        }
    }

    // Always make the submit call and return its response
    const submitResponse = await fetchEB('/rte/submit/api/submit/', {
        method: 'POST',
        body: JSON.stringify(
            deepKeysToSnake({
                reporter_email: email,
                event_id: eventId,
                report_message: reportMessage,
                report_reason: reportReason,
                user_id: userId,
                event_url: eventUrl,
                event_name: eventName,
                regulation: regulation,
            }),
        ),
    });
    return submitResponse;
};
